export const APP_URL = '/homepage'
